import { render, staticRenderFns } from "./reportsInternet.vue?vue&type=template&id=c47e3be2&scoped=true"
import script from "./reportsInternet.vue?vue&type=script&lang=js"
export * from "./reportsInternet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c47e3be2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c47e3be2')) {
      api.createRecord('c47e3be2', component.options)
    } else {
      api.reload('c47e3be2', component.options)
    }
    module.hot.accept("./reportsInternet.vue?vue&type=template&id=c47e3be2&scoped=true", function () {
      api.rerender('c47e3be2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/customer/reportsInternet.vue"
export default component.exports